import React, { FC } from 'react';
import { Grid, Typography } from '@material-ui/core';
import { useStyles } from './styles';

interface Props {
    day: string;
    month: string;
}

const EventDateLarge: FC<Props> = ({ day, month }) => {
    const classes = useStyles();

    return (
        <Grid container direction="column" alignItems="flex-start">
            <Typography className={classes.day}>{day}</Typography>
            <Typography className={classes.month}>{month}</Typography>
        </Grid>
    );
};

export default EventDateLarge;
